import styles from './style.postcss';

import React, { Component } from 'react';
import is from 'is_js';
import PropTypes from 'prop-types';

import { buildUrl } from 'domain/Api';
import { exporter } from 'domain/Exporter';
import Languages from 'domain/Languages';

import { ConfirmDialog, ErrorDialog, log } from 'omni-common-ui';
import { IdpStatus } from 'components/IndividualDevelopmentPlanStatus';
import LanguageRadio from 'components/LanguageRadio';

const EXPORT_FILENAME = 'Progress Reports.pdf';
const EXPORT_MIME_TYPE = 'application/pdf';

class ExportAllHandler extends Component {
  constructor() {
    super();
    this.state = {
      isExportRequested: false,
    };

    this._onLanguageChanged = this._onLanguageChanged.bind(this);
  }

  componentWillMount() {
    this.setState({ choosedLanguageCode: this.props.languageCode });
  }

  _close() {
    const { buildRoute, pushRoute, groupId, groupIdpId } = this.props;
    pushRoute(buildRoute(`/group/${groupId}/progress-report/${groupIdpId}`));
  }

  _performExport() {
    const { groupIdpId } = this.props;

    if (is.falsy(groupIdpId)) {
      log.error('ExportAllHandler is not exporting - groupIdpId is not set!');
      return;
    }

    const url =
      buildUrl(`/group-compulsory-idps/${groupIdpId}/printings?` +
        `languageCode=${this.state.choosedLanguageCode || Languages.defaultLanguageCode}`);

    exporter.get(url,
      EXPORT_FILENAME,
      false,
      EXPORT_MIME_TYPE)
      .then(() => { this._close(); })
      .catch(() => { this.setState({ isExportErrorOccurred: true }); });

    this.setState({ isExportRequested: true });
  }

  _onLanguageChanged(languageCode) {
    this.setState({ choosedLanguageCode: languageCode });
  }


  _isDefaultLanguage() {
    if (! this.props.languageCode) return true;
    return Languages.defaultLanguageCode === this.props.languageCode;
  }

  _renderLanguageRadio() {
    return <LanguageRadio name="language-picker"
        languageCode={this.props.languageCode}
        onChecked={this._onLanguageChanged}
        choosedLanguageCode={this.state.choosedLanguageCode} />;
  }

  render() {
    const { individualDevelopmentPlanList } = this.props;

    if (this.state.isExportErrorOccurred) {
      return <ErrorDialog isOpen
          onConfirmClick={() => { this._close(); }} />;
    }

    const exportCount = countByStatus(IdpStatus.COMPLETED);
    const bestCaseCount = individualDevelopmentPlanList.size;
    const notAvailableCount = bestCaseCount - exportCount;


    // no reports are exportable :( (we shouldn't end up here though)
    if (exportCount <= 0) {
      return <ConfirmDialog isOpen
          title="No reports are available"
          primaryButtonContent="Close"
          onPrimaryClick={() => this._close()}
          onRequestClose={() => this._close()}>
        <p className={styles.ExportAllHandler_feedback_noneToExport}>
          There are no reports available to export.
        </p>
      </ConfirmDialog>;
    }

    // all reports are exportable; no need to display stats.
    if (exportCount === bestCaseCount) {
      if (! this._isDefaultLanguage()) {
        return <ConfirmDialog isOpen
            isLoading={this.state.isExportRequested}
            title="Choose Language:"
            primaryButtonContent="Export"
            secondaryButtonContent="Cancel"
            onPrimaryClick={() => this._performExport()}
            onSecondaryClick={() => this._close()}
            onRequestClose={() => this._close()}>
          <div className={styles.ExportAllHandler_feedback_content}>
            <div className={styles.ExportAllHandler_feedback_languageRadio}>
              {this._renderLanguageRadio()}
            </div>
          </div>
        </ConfirmDialog>;
      }
      // the export starts automatically!
      ! this.state.isExportRequested && this._performExport();
      return <ConfirmDialog isOpen
          isLoading
          isButtonless
          title="Exporting reports, please wait">
        <div className={styles.ExportAllHandler_feedback_exportingImmediately} />
      </ConfirmDialog>;
    }

    return <ConfirmDialog isOpen
        isLoading={this.state.isExportRequested}
        title={`Exporting ${exportCount} of ${bestCaseCount} reports`}
        primaryButtonContent="Export"
        secondaryButtonContent="Cancel"
        onPrimaryClick={() => this._performExport()}
        onSecondaryClick={() => this._close()}
        onRequestClose={() => this._close()}>
      <div className={styles.ExportAllHandler_feedback_content}>
        {notAvailableCount > 0 ?
          <p className={styles.ExportAllHandler_feedback_someNotAvailable}
              data-not-available-count={notAvailableCount}>
            {notAvailableCount}
            {notAvailableCount > 1 ? ' reports are ' : ' report is '}
            not approved and cannot be exported
          </p> :
          null}
        {! this._isDefaultLanguage() &&
          <div className={styles.ExportAllHandler_feedback_divider} />}
        {! this._isDefaultLanguage() &&
          <div className={styles.ExportAllHandler_feedback_languageRadio}>
            <span>Choose Language:</span>
            {this._renderLanguageRadio()}
          </div>}
      </div>
    </ConfirmDialog>;

    function countByStatus(status) {
      return individualDevelopmentPlanList.filter((report) =>
        is.string(report.status) && report.status.toLowerCase() === status
      ).size;
    }
  }
}

ExportAllHandler.propTypes = {
  individualDevelopmentPlanList: PropTypes.shape({
    filter: PropTypes.func.isRequired,
  }).isRequired,
  groupIdpId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  languageCode: PropTypes.string.isRequired,
  buildRoute: PropTypes.func.isRequired,
  pushRoute: PropTypes.func.isRequired,
  reportName: PropTypes.string.isRequired,
};

export default ExportAllHandler;



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanListView/ExportAllHandler/index.jsx